<template>
  <button :type="type" @click="onClick" class="button">
    <slot>Button</slot>
  </button>
</template>

<script>

export default {
  props: {
    type: String,
    disabled: Boolean,
    onClick: {
      type: Function,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/design-turin/buttonComponent.scss";
</style>